<template>
  <div class="row-container">
    <v-tooltip bottom v-if="image">
      <template v-slot:activator="{ on }">
        <v-img v-if="image" :src="image" height="110" width="110" v-on="on"/>
      </template>
      <img v-if="image" :src="image" style="max-width: 100%; max-height: 250px;"/>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: ['src', 'srcSet', 'backupSet'],
  computed: {
    image () {
      if (this.src) {
        return this.src
      }
      if (this.srcSet && this.srcSet.x1) {
        return this.srcSet.x1
      }
      if (this.backupSet && this.backupSet.x1) {
        return this.backupSet.x1
      }
      return null
    }
  }
}
</script>

<style scoped>
  .row-container {
    height: 110px;
    min-width: 110px;
  }
</style>
